var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.getSrc(),"srcset":_vm.getSrcSet(),"height":`${_vm.size * 10}px`}})
}
var staticRenderFns = []

export { render, staticRenderFns }